import React from 'react'
import SummaryView from '../detail/SummaryView'

const IceSkatingView = (props) => {
  const { data: { summary = {} } } = props
  const fieldsOfInterest = ['start_date', 'distance', 'duration', 'avg_speed', 'avg_acceleration']

  return <SummaryView fieldsOfInterest={fieldsOfInterest} summary={summary} />
}

export default IceSkatingView
